import {
  emptyWorksheetGridClientFilters,
} from "src/app/core/models/admissions.model";
import { SelectableEnumerationItem } from "src/app/core/models/lookup.model";
import { AdmissionsService } from "src/app/core/services/admissions.service";

function worksheetFacetHasNarrowing(rows: SelectableEnumerationItem[] | undefined): boolean {
  return (rows ?? []).some((x) => {
    if (!x?.isSelected) {
      return false;
    }
    const v = String(x.value ?? "").trim();
    return !!v && v.toLowerCase() !== "all";
  });
}

/** How many distinct worksheet filter criteria are active on {@link AdmissionsService}. */
export function countWorksheetAppliedFilters(s: AdmissionsService): number {
  const gt = { ...emptyWorksheetGridClientFilters(), ...(s.worksheetGridText ?? {}) };
  let n = 0;
  if ((gt.namePatientKeysContains ?? "").toString().trim()) {
    n += 1;
  }
  if (s.getActiveReferralSourceValues().length > 0) {
    n += 1;
  }
  if (worksheetFacetHasNarrowing(s.physicianFilter)) {
    n += 1;
  }
  if (worksheetFacetHasNarrowing(s.resourcesFilter)) {
    n += 1;
  }
  if (worksheetFacetHasNarrowing(s.locationFilter)) {
    n += 1;
  }
  if (worksheetFacetHasNarrowing(s.visitTypeFilter)) {
    n += 1;
  }
  if (worksheetFacetHasNarrowing(s.serviceFilter)) {
    n += 1;
  }
  if (worksheetFacetHasNarrowing(s.encounerStatusList)) {
    n += 1;
  }
  if (
    (gt.dosContains ?? "").toString().trim() ||
    s.worksheetUserCommittedDosRange ||
    (gt.dosDayKeysContains ?? "").toString().trim()
  ) {
    n += 1;
  }
  if ((s.worksheetCreatedOnIso ?? "").trim()) {
    n += 1;
  }
  if ((s.worksheetUpdatedOnIso ?? "").trim()) {
    n += 1;
  }
  if ((s.worksheetActivityDateStartIso ?? "").trim()) {
    n += 1;
  }
  if ((gt.refStatusContains ?? "").toString().trim()) {
    n += 1;
  }
  if ((gt.queueContains ?? "").toString().trim()) {
    n += 1;
  }
  n += (gt.referralNotificationFilters ?? []).filter((x) => String(x ?? "").trim()).length;
  if ((gt.coordinatorContains ?? "").toString().trim()) {
    n += 1;
  }
  if ((gt.visitTypeContains ?? "").toString().trim()) {
    n += 1;
  }
  if ((gt.authStatusContains ?? "").toString().trim()) {
    n += 1;
  }
  if ((gt.eligibilityContains ?? "").toString().trim()) {
    n += 1;
  }
  if ((gt.claimStatusContains ?? "").toString().trim()) {
    n += 1;
  }
  if ((gt.payerContains ?? "").toString().trim()) {
    n += 1;
  }
  if ((gt.dobContains ?? "").toString().trim()) {
    n += 1;
  }
  const nameG = (gt.nameContains ?? "").toString().trim();
  const sq = (s.searchQuery ?? "").toString().trim();
  if (nameG && nameG !== sq) {
    n += 1;
  }
  return n;
}

export function worksheetAppliedFiltersActive(s: AdmissionsService): boolean {
  return countWorksheetAppliedFilters(s) > 0;
}
